export default __webpack_public_path__ + "static/bffwdEkt-98fe3503acfa1653d646fd3e98579b59.svg";